import React from 'react'
import { Navigate, Link, useLocation, useMatch } from 'react-router-dom'
import { Container } from 'react-bootstrap'

import * as Request from '../../utilities/request'
import * as Url from '../../utilities/url'
import { AppContext } from '../../App'
import { Loading } from '../../components/ui/Loading/Loading'

const Callback = () => {
	const match = useMatch('/:xero/callback')
	const xeroApp = match?.params.xero || ''

	const { appState } = React.useContext(AppContext)
	const location = useLocation()

	const [isReady, updateIsReady] = React.useState<boolean>(false)
	const [failMessage, updateFailMessage] = React.useState<string>('')

	const hasRun = React.useRef(false)

	React.useEffect(() => {
		if (hasRun.current) {
			return
		}
		if (
			appState.authState.isLoggedIn &&
			appState.accounts.length > 0 &&
			appState.permission.roleID &&
			appState.authState.invitationAccepted &&
			!Url.getUrlSearchParam(location.search, 'xerror')
		) {
			hasRun.current = true
			const exchangeKeys = async () => {
				const search = location.search.replace('?xcode', '?code')

				try {
					await Request.get(`${xeroApp}/tokens/billy` + search)
				} catch (err) {
					console.log('Xero tokens error: ', err)
					if (err instanceof Error) {
						updateFailMessage(err.message)
					}
				}

				updateIsReady(true)
			}

			exchangeKeys()
		}
	}, [location.search, appState]) // eslint-disable-line

	if (Url.getUrlSearchParam(location.search, 'xerror')) {
		return (
			<Container>
				<p>
					Authentication with Xero failed, <Link to="/xero/connections">go to connections page</Link>
				</p>
			</Container>
		)
	} else if (isReady) {
		return <Navigate to={'/xero/connections'} />
	} else {
		if (failMessage === '') {
			return (
				<div className="center-flex p-5">
					<Loading show />
				</div>
			)
		} else {
			return (
				<Container>
					<p>{failMessage}</p>
				</Container>
			)
		}
	}
}

export default Callback
